var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-1{stroke:#acb5bf;}.cls-2{stroke:#ffd200;}"));
var _ref3 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 41,
  y1: 31,
  x2: 47,
  y2: 31
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 13,
  y1: 31,
  x2: 33,
  y2: 31
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M45,31V24a3,3,0,0,0-3-3H39l-4-8H16l-4,8H4a3,3,0,0,0-3,3v7H5"
});
var _ref6 = /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "17 21 19 17 21 17"
});
var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 9,
  cy: 31,
  r: 4
});
var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 37,
  cy: 31,
  r: 4
});
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "car") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.b60dbb36.svg";
export { ForwardRef as ReactComponent };